import * as React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const DistributionTable = ({ metrics, category }) => {
  const sortedMetrics = React.useMemo(
    () =>
      Array.isArray(metrics)
        ? [...metrics].sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0))
        : [],
    [metrics],
  );

  if (sortedMetrics.length === 0) {
    return null;
  }

  return (
    <Table
      size="small"
      stickyHeader
      sx={{
        borderTop: 1,
        borderColor: '#eee',
        mt: 1,
        '& th': { color: '#666' },
        '& th:nth-of-type(1), td:nth-of-type(1)': { pr: 0 },
        '& th:nth-of-type(2), td:nth-of-type(2)': { pl: 0 },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell
            sx={{ fontWeight: 600, fontSize: '.875rem', bgcolor: '#fbfbfc' }}
          >
            {category}
          </TableCell>
          <TableCell
            sx={{
              fontWeight: 600,
              fontSize: '.875rem',
              bgcolor: '#fbfbfc',
              textAlign: 'right',
            }}
          >
            %
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody
        sx={{
          '& .MuiTableRow-root:nth-last-of-type(1) td': { borderBottom: 0 },
          '& th': { whiteSpace: 'nowrap' },
          '& td:nth-of-type(1)': { pr: 0 },
          '& td:nth-of-type(2)': { pl: 0 },
        }}
      >
        {sortedMetrics.map((d, i) => (
          <TableRow key={d?.label ?? i} sx={{ bgcolor: '#fff' }}>
            <TableCell
              className="px-2 text-capitalize"
              sx={{ fontSize: '.875rem', fontWeight: 600, textAlign: 'left', color: '#444' }}
            >
              {d?.label}
            </TableCell>
            <TableCell
              className="px-2 text-capitalize"
              sx={{ fontSize: '.875rem', fontWeight: 600, textAlign: 'right', color: '#444' }}
            >
              {d?.value}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DistributionTable;
